/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDocumented } from '../../models/paginated-documented';
import { RuoloResDto } from '../../models/ruolo-res-dto';

export interface RuoliControllerFindManyRoles$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 1
   *
   *
   *
   * **Max Value:** -1
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by standardName query param.
   *
   * **Format:** filter.standardName={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.standardName=$btw:John Doe&filter.standardName=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.standardName'?: Array<string>;

  /**
   * Filter by standardCode query param.
   *
   * **Format:** filter.standardCode={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.standardCode=$btw:John Doe&filter.standardCode=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.standardCode'?: Array<string>;

  /**
   * Filter by description query param.
   *
   * **Format:** filter.description={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.description=$btw:John Doe&filter.description=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.description'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=standardName:DESC&sortBy=standardCode:DESC
   *
   *
   * **Default Value:** standardName:ASC
   *
   * **Available Fields**
   * - standardName
   *
   * - standardCode
   *
   * - description
   */
  sortBy?: Array<
    | 'standardName:ASC'
    | 'standardName:DESC'
    | 'standardCode:ASC'
    | 'standardCode:DESC'
    | 'description:ASC'
    | 'description:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** standardName,standardCode,description
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - standardName
   *
   * - standardCode
   *
   * - description
   */
  searchBy?: Array<string>;
}

export function ruoliControllerFindManyRoles(
  http: HttpClient,
  rootUrl: string,
  params?: RuoliControllerFindManyRoles$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<RuoloResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          standardName?: string | Array<string>;
          standardCode?: string | Array<string>;
          description?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    ruoliControllerFindManyRoles.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.standardName', params['filter.standardName'], {});
    rb.query('filter.standardCode', params['filter.standardCode'], {});
    rb.query('filter.description', params['filter.description'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<RuoloResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                standardName?: string | Array<string>;
                standardCode?: string | Array<string>;
                description?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

ruoliControllerFindManyRoles.PATH = '/admin/ruoli';
